import Spinner from "../../Spinner";
import * as Styles from "./styles";

type Props = {
  text: string;
  htmlFor: string;
  maxLength?: number;
  usedLength?: number;
  required?: boolean;
  ignoreLengthInfo?: boolean;
  loading?: boolean;
  infoMessage?: string;
};

const Label = ({ text, htmlFor, maxLength, usedLength, required, ignoreLengthInfo, loading, infoMessage }: Props) => {
  return (
    <Styles.Label htmlFor={htmlFor}>
      <Styles.Container>
        <Styles.InfoSection>
          {text}
          {required && "*"}
        </Styles.InfoSection>
        <Styles.InfoSection>
          {!loading && <Styles.InfoSectionMessage>{infoMessage}</Styles.InfoSectionMessage>}
          {loading ? <Spinner /> : maxLength && !ignoreLengthInfo && `${usedLength || 0}/${maxLength}`}
        </Styles.InfoSection>
      </Styles.Container>
    </Styles.Label>
  );
};

export default Label;
